import {
  firstMenubarRouterLink,
  type UiMenubarItem,
} from '@system-dyg/shared/ui/shell';

export const ERP_MENUBAR_ITEMS: Record<string, readonly UiMenubarItem[]> = {
  treasury: [
    { id: 'tre-income',       label: 'Ingresos', routerLink: '/treasury/income/income' },
    { id: 'tre-expenses',     label: 'Egresos', routerLink: '/treasury/expenses/expenses' },
    { id: 'tre-transfers',    label: 'Traspasos', routerLink: '/treasury/transfers/transfers' },
    { id: 'tre-cat-bank-accounts', label: 'Cuentas bancarias', routerLink: '/treasury/bank-accounts/bank-accounts' },
    { id: 'tre-cat-cash-boxes',    label: 'Cajas efectivo',    routerLink: '/treasury/cash-boxes/cash-boxes' },
    { id: 'tre-debtors',      label: 'Deudores', routerLink: '/treasury/debtors/debtors' },
    { id: 'tre-creditors',    label: 'Acreedores', routerLink: '/treasury/creditors/creditors' },
    { id: 'tre-investments',  label: 'Inversiones', routerLink: '/treasury/investments/investments' },
    { id: 'tre-credits',      label: 'Créditos', routerLink: '/treasury/credits' },
    {
      id: 'tre-catalogs',
      label: 'Catálogos',
      items: [
        { id: 'tre-cat-banks', label: 'Instituciones bancarias', routerLink: '/treasury/catalogs/bank-institutions' },
        { id: 'tre-cat-credit-types', label: 'Tipos de créditos' },
      ],
    },
    {
      id: 'tre-reports',
      label: 'Reportes',
      items: [
        { id: 'tre-rep-cashflow',    label: 'Flujo de efectivo', routerLink: '/treasury/reports/cash-flow' },
        { id: 'tre-rep-banks',       label: 'Bancos',            routerLink: '/treasury/reports/banks' },
        { id: 'tre-rep-cash-boxes',  label: 'Cajas efectivo',    routerLink: '/treasury/reports/cash-boxes' },
        { id: 'tre-rep-debtors',     label: 'Deudores',          routerLink: '/treasury/reports/debtors' },
        { id: 'tre-rep-creditors',   label: 'Acreedores',        routerLink: '/treasury/reports/creditors' },
        { id: 'tre-rep-investments', label: 'Inversiones',       routerLink: '/treasury/reports/investments' },
      ],
    },
  ],

  'purchases-expenses': [
    {
      id: 'pxe-requisitions',
      label: 'Requisiciones',
      items: [
        { id: 'pxe-req-purchases', label: 'Compras', routerLink: '/purchases-expenses/requisitions/purchases' },
        { id: 'pxe-req-expenses',  label: 'Gastos',  routerLink: '/purchases-expenses/requisitions/expenses' },
        { id: 'pxe-req-advances',  label: 'Anticipos', routerLink: '/purchases-expenses/requisitions/advances' },
      ],
    },
    {
      id: 'pxe-ord-purchase-orders',
      label: 'Ordenes de compra',
      routerLink: '/purchases-expenses/purchase-orders/purchase-orders',
    },
    {
      id: 'pxe-exp-expenses',
      label: 'Gastos',
      routerLink: '/purchases-expenses/expenses/expenses',
    },
    {
      id: 'pxe-adv-advances',
      label: 'Anticipos',
      routerLink: '/purchases-expenses/advances/advances',
    },
    {
      id: 'pxe-reports',
      label: 'Reportes',
      items: [
        { id: 'pxe-rep-requisitions', label: 'Requisiciones', routerLink: '/purchases-expenses/reports/requisitions' },
        { id: 'pxe-rep-orders',       label: 'Ordenes de compra', routerLink: '/purchases-expenses/reports/purchase-orders' },
        { id: 'pxe-rep-expenses',     label: 'Gastos', routerLink: '/purchases-expenses/reports/expenses' },
        { id: 'pxe-rep-advances',     label: 'Anticipos', routerLink: '/purchases-expenses/reports/advances' },
      ],
    },
  ],

  warehouses: [
    { id: 'wh-warehouses', label: 'Almacenes', routerLink: '/warehouses/warehouses' },
    {
      id: 'wh-movements',
      label: 'Movimientos',
      items: [
        { id: 'wh-mov-reception', label: 'Recepción', routerLink: '/warehouses/movements/reception' },
        { id: 'wh-mov-entries', label: 'Entradas', routerLink: '/warehouses/movements/entries' },
        { id: 'wh-mov-exits', label: 'Salidas', routerLink: '/warehouses/movements/exits' },
        { id: 'wh-mov-transfers', label: 'Traspasos', routerLink: '/warehouses/movements/transfers' },
      ],
    },
    {
      id: 'wh-kardex',
      label: 'Kardex',
      routerLink: '/warehouses/kardex',
    },
    {
      id: 'wh-reports',
      label: 'Reportes',
      items: [
        { id: 'wh-rep-stock', label: 'Existencias', routerLink: '/warehouses/reports/stock' },
        { id: 'wh-rep-movements', label: 'Movimientos', routerLink: '/warehouses/reports/movements' },
      ],
    },
  ],

  construction: [
    {
      id: 'con-projects',
      label: 'Proyectos',
      routerLink: '/construction/projects/projects',
    },
    { id: 'con-estimates',  label: 'Estimaciones' },
    { id: 'con-progress',   label: 'Avance de obra' },
  ],

  suppliers: [
    {
      id: 'sup-suppliers-menu',
      label: 'Proveedores',
      items: [
        { id: 'sup-suppliers', label: 'Proveedores', routerLink: '/suppliers/suppliers' },
        {
          id: 'sup-registration-requests',
          label: 'Solicitudes de registro',
          routerLink: '/suppliers/registration-requests',
        },
      ],
    },
    { id: 'sup-schedule',  label: 'Programación de pagos', routerLink: '/suppliers/payment-scheduling/payment-scheduling' },
    {
      id: 'sup-payments',
      label: 'Pagos',
      items: [
        { id: 'sup-pay-payments', label: 'Pagos', routerLink: '/suppliers/payments/payments' },
        {
          id: 'sup-pay-application',
          label: 'Aplicación de programación',
          routerLink: '/suppliers/payments/programming-application',
        },
      ],
    },
    {
      id: 'sup-catalogs',
      label: 'Catálogos',
      items: [
        {
          id: 'sup-cat-service-type',
          label: 'Tipo de servicio',
          routerLink: '/suppliers/catalogs/service-type',
        },
      ],
    },
    {
      id: 'sup-reports',
      label: 'Reportes',
      items: [
        {
          id: 'sup-rep-summary',
          label: 'Resumen',
          routerLink: '/suppliers/reports/summary',
        },
        {
          id: 'sup-rep-account',
          label: 'Estado de cuenta',
          routerLink: '/suppliers/reports/account-statement',
        },
        {
          id: 'sup-rep-schedule',
          label: 'Programación de pagos',
          routerLink: '/suppliers/reports/payment-scheduling',
        },
        {
          id: 'sup-rep-payments',
          label: 'Pagos',
          routerLink: '/suppliers/reports/payments',
        },
      ],
    },
  ],

  sales: [
    { id: 'sal-sales',  label: 'Ventas', routerLink: '/sales/sales' },
    { id: 'sal-blocks', label: 'Bloqueos' },
    { id: 'sal-quotes', label: 'Cotizaciones', routerLink: '/sales/quotes' },
    {
      id: 'sal-reports',
      label: 'Reportes',
      items: [
        { id: 'sal-rep-sales',  label: 'Ventas', routerLink: '/sales/reports/sales' },
        { id: 'sal-rep-blocks', label: 'Bloqueos', routerLink: '/sales/reports/blocks' },
        { id: 'sal-rep-quotes', label: 'Cotizaciones', routerLink: '/sales/reports/quotes' },
      ],
    },
  ],

  clients: [
    { id: 'cli-clients',   label: 'Clientes', routerLink: '/clients/clients' },
    { id: 'cli-collection', label: 'Cobranza' },
    {
      id: 'cli-reports',
      label: 'Reportes',
      items: [
        { id: 'cli-rep-summary',    label: 'Resumen', routerLink: '/clients/reports/summary' },
        { id: 'cli-rep-account',    label: 'Estado de cuenta', routerLink: '/clients/reports/account-statement' },
        { id: 'cli-rep-collection', label: 'Cobranza', routerLink: '/clients/reports/collection' },
      ],
    },
  ],

  titulation: [
    {
      id: 'tit-files',
      label: 'Expedientes',
      items: [
        { id: 'tit-fil-files',    label: 'Expedientes', routerLink: '/titulation/files/files' },
        { id: 'tit-fil-clients',  label: 'Clientes' },
        { id: 'tit-fil-managers', label: 'Gerentes' },
        { id: 'tit-fil-advisors', label: 'Asesores' },
        { id: 'tit-fil-agencies', label: 'Inmobiliarias' },
      ],
    },
    {
      id: 'tit-deed',
      label: 'Escrituración',
      items: [
        { id: 'tit-dee-deeding',  label: 'Escrituración' },
        { id: 'tit-dee-notaries', label: 'Notarias' },
      ],
    },
  ],

  'human-resources': [
    { id: 'hr-employees', label: 'Empleados', routerLink: '/human-resources/employees/employees' },
    { id: 'hr-payroll',   label: 'Nóminas',   routerLink: '/human-resources/payroll/payroll' },
    {
      id: 'hr-catalogs',
      label: 'Catálogos',
      items: [
        {
          id: 'hr-cat-contpai-nominas',
          label: 'Contpaqi Nominas',
          items: [
            {
              id: 'hr-cat-payment-bases',
              label: 'Base de pago',
              routerLink: '/human-resources/catalogs/contpai-nominas/payment-bases',
            },
            {
              id: 'hr-cat-benefit-types',
              label: 'Tipo de prestación',
              routerLink: '/human-resources/catalogs/contpai-nominas/benefit-types',
            },
            {
              id: 'hr-cat-shifts',
              label: 'Turnos',
              routerLink: '/human-resources/catalogs/contpai-nominas/shifts',
            },
            {
              id: 'hr-cat-workday-types',
              label: 'Tipo de jornada',
              routerLink: '/human-resources/catalogs/contpai-nominas/workday-types',
            },
          ],
        },
        { id: 'hr-cat-positions', label: 'Puestos', routerLink: '/human-resources/catalogs/positions' },
        { id: 'hr-cat-departments', label: 'Departamentos', routerLink: '/human-resources/catalogs/departments' },
        { id: 'hr-cat-perceptions', label: 'Percepciones', routerLink: '/human-resources/catalogs/perceptions' },
        { id: 'hr-cat-deductions', label: 'Deducciones', routerLink: '/human-resources/catalogs/deductions' },
        { id: 'hr-cat-locations', label: 'Ubicaciones', routerLink: '/human-resources/catalogs/locations' },
      ],
    },
    {
      id: 'hr-reports',
      label: 'Reportes',
      items: [
        { id: 'hr-rep-employees', label: 'Empleados', routerLink: '/human-resources/reports/employees' },
        { id: 'hr-rep-payroll', label: 'Nóminas', routerLink: '/human-resources/reports/payroll' },
      ],
    },
  ],


  'fixed-assets': [
    { id: 'fa-assets',        label: 'Activos', routerLink: '/fixed-assets/assets/assets' },
    { id: 'fa-depreciation',  label: 'Depreciación' },
    {
      id: 'fa-catalogs',
      label: 'Catálogos',
      items: [
        { id: 'fa-cat-types', label: 'Tipos', routerLink: '/fixed-assets/catalogs/types' },
      ],
    },
    {
      id: 'fa-reports',
      label: 'Reportes',
      items: [
        { id: 'fa-rep-assets', label: 'Activo fijo', routerLink: '/fixed-assets/reports/assets' },
        { id: 'fa-rep-depreciation', label: 'Depreciación', routerLink: '/fixed-assets/reports/depreciation' },
      ],
    },
  ],

  accounting: [
    { id: 'acc-companies', label: 'Empresas', routerLink: '/accounting/companies/companies' },
    {
      id: 'acc-policies',
      label: 'Pólizas',
      items: [
        { id: 'acc-pol-policies',    label: 'Pólizas', routerLink: '/accounting/policies/policies' },
        { id: 'acc-pol-transfers',   label: 'Traspasos de movimientos', routerLink: '/accounting/policies/movement-transfers' },
        { id: 'acc-pol-download',    label: 'Bajar pólizas', routerLink: '/accounting/policies/download-policies' },
        { id: 'acc-pol-upload',      label: 'Cargar pólizas', routerLink: '/accounting/policies/upload-policies' },
        { id: 'acc-pol-erp-docs',    label: 'Documentos ERP', routerLink: '/accounting/policies/erp-documents' },
      ],
    },
    {
      id: 'acc-catalogs',
      label: 'Cuentas contables',
      items: [
        { id: 'acc-cat-chart', label: 'Cuentas contables', routerLink: '/accounting/accounting-accounts/accounting-accounts' },
        { id: 'acc-cat-structure', label: 'Estructura', routerLink: '/accounting/accounting-accounts/structure' },
      ],
    },
    {
      id: 'acc-reports',
      label: 'Reportes',
      items: [
        { id: 'acc-rep-financial-position', label: 'Estado de situación financiera', routerLink: '/accounting/reports/financial-position' },
        { id: 'acc-rep-income', label: 'Estado de resultados', routerLink: '/accounting/reports/income-statement' },
        { id: 'acc-rep-cash-flow', label: 'Estado de flujos de efectivo', routerLink: '/accounting/reports/cash-flow' },
        { id: 'acc-rep-equity-changes', label: 'Estado de cambios en el capital contable', routerLink: '/accounting/reports/equity-changes' },
        { id: 'acc-rep-trial-balance', label: 'Balanza de comprobación', routerLink: '/accounting/reports/trial-balance' },
        { id: 'acc-rep-auxiliary-movements', label: 'Movimientos auxiliares', routerLink: '/accounting/reports/auxiliary-movements' },
        { id: 'acc-rep-analytics', label: 'Analiticas', routerLink: '/accounting/reports/analytics' },
        { id: 'acc-rep-policy-journal', label: 'Diario de polizas', routerLink: '/accounting/reports/policy-journal' },
      ],
    },
    {
      id: 'acc-cfdi-download',
      label: 'Descarga CFDI',
      items: [
        {
          id: 'acc-cfdi-dashboard',
          label: 'Panel de control',
          routerLink: '/accounting/cfdi-download/dashboard',
        },
        { id: 'acc-cfdi-issued', label: 'Emitidos', routerLink: '/accounting/cfdi-download/issued/income' },
        { id: 'acc-cfdi-received', label: 'Recibidos', routerLink: '/accounting/cfdi-download/received/income' },
      ],
    },
    {
      id: 'acc-tax-compliance',
      label: 'Impuestos y cumplimiento',
      items: [
        { id: 'acc-tax-dashboard', label: 'Tablero fiscal', routerLink: '/accounting/tax-compliance/tax-dashboard/summary' },
        { id: 'acc-tax-declarations', label: 'Declaraciones', routerLink: '/accounting/tax-compliance/declarations' },
        { id: 'acc-tax-eaccounting', label: 'Contabilidad electrónica', routerLink: '/accounting/tax-compliance/electronic-accounting' },
        { id: 'acc-tax-diot', label: 'DIOT', routerLink: '/accounting/tax-compliance/diot' },
        { id: 'acc-tax-efos', label: 'EFOS', routerLink: '/accounting/tax-compliance/efos' },
      ],
    },
    {
      id: 'acc-config',
      label: 'Configuración',
      items: [
        { id: 'acc-cfg-periods',    label: 'Periodos', routerLink: '/accounting/configuration/periods' },
        { id: 'acc-cfg-templates',  label: 'Plantillas documentos ERP', routerLink: '/accounting/configuration/erp-document-templates' },
      ],
    },
  ],

  audit: [
    { id: 'aud-banks',        label: 'Bancos', routerLink: '/audit/banks' },
    { id: 'aud-sales',        label: 'Ventas' },
    { id: 'aud-receivable',   label: 'Cuentas por cobrar' },
    { id: 'aud-purchases',    label: 'Compras' },
    { id: 'aud-payable',      label: 'Cuentas por pagar' },
    { id: 'aud-expenses',     label: 'Gastos' },
    { id: 'aud-sat',          label: 'Compulsa SAT' },
  ],
};

/** Primera sección navegable del menú de un módulo, si tiene vista. */
export function firstErpModulePath(moduleId: string): string | null {
  const link = firstMenubarRouterLink(ERP_MENUBAR_ITEMS[moduleId]);
  return link ? link.replace(/^\/+/, '') : null;
}

/** Entrada de un módulo que sí tiene una sección navegable. */
export function erpModuleEntry(moduleId: string): string {
  const path = firstErpModulePath(moduleId);
  if (!path) {
    throw new Error(`El módulo ERP "${moduleId}" no tiene una sección navegable.`);
  }
  return path;
}
